// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__xpjhK","colMin":"styles_colMin__2lJa5","colCheckbox":"styles_colCheckbox__3T1MK"};